import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { STEPS, type StepId } from './ayat.ts'

/** Sticky bottom action of each step (above the tab bar on phones). */
export function CtaBar({ children }: { children: ReactNode }) {
  return <div className="cta-bar"><div className="cta-in">{children}</div></div>
}

export function NextStep({ day, step }: { day: number; step: StepId }) {
  const label = STEPS.find((s) => s.id === step)!.label
  return <Link className="btn btn-primary btn-block" to={`/ayat/${day}/${step}`}>Lanjut ke {label}</Link>
}
